import { Box, Typography, useTheme } from '@mui/joy';
import ControlPanelLayout, {
	IControlPanelLayoutProps
} from '../Controls/ControlPanelLayout';
import DonorLegend from './DonorLegend';
import { useMediaQuery } from '../../hooks';
import { useRoute } from '../../providers/RouteProvider';
import DotPlots from './DotPlots';
import DonorDisaggCharts from './DonorDisaggCharts';
import { useDonorSectionData } from '../../providers/DonorSectionProvider';
//import { DataKey } from '../../lib/model';
//import { useControls } from '../../providers/ControlProvider';

interface IProps extends IControlPanelLayoutProps {
	topic: string;
	print?: boolean;
}
const DonorLayout = ({ topic, page, title, text, print = false }: IProps) => {
	const theme = useTheme();
	const { raceFilter } = useRoute();

	const titles: { [x: string]: string[] } = {
		gender: ['Men Donors', 'Women Donors'],
		education: ['College Educated Donors', 'Non-College Educated Donors'],
		race: ['Asian Donors', 'Black Donors', 'Latino Donors', 'White Donors'],
		maritalStatus: ['Married Donors', 'Unmarried Donors'],
		party: ['Democratic Donors', 'Other Donors', 'Republican Donors'],
		age: ['Donors Under 40', 'Donors 40-64', 'Donors 65+']
	};

	const matches3 = useMediaQuery(theme.breakpoints.up(1140));
	const matches = useMediaQuery(theme.breakpoints.up('md'));

	const isFiltered = page === 'donorNational' && raceFilter[0] === 'true';
	const { chartData } = useDonorSectionData();
	const hasGroupsThatNeedLegend = () => {
		const groups = chartData
			?.flat()
			.map((array) => {
				return array?.map((item) => item.group);
			})
			.flat();
		const xx = groups
			?.map((grp) => {
				if (grp?.length) {
					if (
						grp.includes('MENA') ||
						grp.includes('NatAm') ||
						grp.includes('AAPI')
					)
						return true;
				} else return null;
			})
			.filter((item) => item);
		return xx?.length ? true : false;
	};
	const showLegend = hasGroupsThatNeedLegend();
	return (
		<>
			<ControlPanelLayout page={page} title={title} text={text} print={print} />
			<Box
				sx={{
					backgroundColor: theme.palette.chartElementsBackground.bg,
					height: '100%',
					padding: { xs: '1rem .5rem', sm: '1rem 3rem' },
					maxHeight: print ? 'unset' : '865px',
					overflowY: print ? 'auto' : 'scroll'
					// '::-webkit-scrollbar': isFiltered
					// 	? {
					// 			backgroundColor: '#f0f0f0',
					// 			borderRadius: '10px',
					// 			width: '7px',
					// 			height: '2px'
					// 	  }
					// 	: {},
					// '::-webkit-scrollbar-thumb': {
					// 	backgroundColor: '#e5e5e5',
					// 	borderRadius: '10px'
					// }
				}}
			>
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns:
							topic === 'party' || topic === 'age'
								? matches3
									? '1fr 1fr 1fr'
									: '1fr'
								: matches
								? '1fr 1fr'
								: '1fr',
						flexGrow: 1,
						mx: { xs: 0, sm: '-2rem' }
					}}
				>
					{titles[topic].map((title, i) => {
						return (
							<>
								<Box
									key={title}
									sx={{
										flex: 1,
										margin: { xs: 0, sm: '1rem 4rem 1rem 2rem' },
										position: 'relative',
										padding: { xs: '0 5.5rem 0 1.5rem', sm: 0 }
									}}
								>
									<Typography
										level='subgroupTitle'
										sx={{
											//height: '2.7rem',
											//maxWidth: '200px',
											whiteSpace: topic === 'age' ? 'nowrap' : 'wrap'
										}}
									>
										{title}
									</Typography>
									{/* this is stack of dot plots: */}
									{!isFiltered ? (
										<DotPlots i={i} topic={topic} page={page} print={print} />
									) : (
										<DonorDisaggCharts topic={topic} i={i} print={print} />
									)}
								</Box>
							</>
						);
					})}
				</Box>
				{matches ? <DonorLegend print={print} /> : null}
			</Box>
			{showLegend ? (
				<Typography
					sx={{
						padding: '2rem 2rem 1rem 3rem',
						backgroundColor: theme.palette.chartElementsBackground.bg
					}}
				>
					MENA - Middle Eastern/North African &nbsp; NatAm - Native
					American/Alaska Native/Native Hawaiian &nbsp; AAPI - Asian
					American/Pacific Islander
				</Typography>
			) : null}
		</>
	);
};

export default DonorLayout;
